module.exports = __webpack_public_path__ + "img/ieee-white.eea509bf.png";